<template>
    <el-row
      class="m-0 width-100-p height-100-p"
      v-loading="loading"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
   <el-col
    :class="[
      'd-flex',
      'align-items-center',
      'mt-20',
      $vuetify.display.width < 700 ? 'px-0 mt-20' : $vuetify.display.width < 1500 ? 'px-10 mt-20' : 'pr-12'
    ]"
    :span="$vuetify.display.width >= 700 ? 8 : 24"
  >
    <div class="row m-0 py-3 width-100-p height-100-p bg-me-primary border-color-light rounded-4 d-flex align-items-center">
      <div class="d-flex justify-content-between align-items-center width-100-p px-2">
        <div class="flex-grow-1 ml-30">
          <p class="font-25-b text-white mb-0">
            {{ dashboardData.supported_charger_count.value.toLocaleString() }}
          </p>
          <p class="font-14 mt-2 text-white mb-0">
            {{ dashboardData.supported_charger_count.title }}
          </p>
        </div>
            <div v-if="$vuetify.display.width <= 700 || $vuetify.display.width >= 1500" class="width-80 height-80 mr-20 ml-3 flex-shrink-0">
              <svg>
                <use href="@/assets/svg/newImports.svg#supported-chargers-80"></use>
              </svg>
            </div>
            <div v-if="$vuetify.display.width > 700 && $vuetify.display.width < 1500" class="width-60 height-60 ml-20 mr-20 ml-3 flex-shrink-0">
              <svg>
                <use href="@/assets/svg/newImports.svg#supported-chargers-60"></use>
              </svg>
            </div>
      </div>
    </div>
  </el-col>
  
  <el-col
    :class="[
      'd-flex',
      'align-items-center',
      'mt-20',
      $vuetify.display.width < 700 ? 'px-0' : $vuetify.display.width < 1500 ? 'px-10' : 'px-2'
    ]"
    :span="$vuetify.display.width >= 700 ? 8 : 24"
  >
    <div class="row m-0 py-3 width-100-p height-100-p bg-me-primary border-color-light rounded-4 d-flex align-items-center">
      <div class="d-flex justify-content-between align-items-center width-100-p px-2">
        <div class="flex-grow-1 ml-30">
          <p class="font-25-b text-white mb-0">
            {{ dashboardData.operational_charger_count.value.toLocaleString() }}
          </p>
          <p class="font-14 mt-2 text-white mb-0">
            {{ $vuetify.display.width >= 700 && $vuetify.display.width < 890 ? "Operati. Chargers" : dashboardData.operational_charger_count.title }}
          </p>
        </div>
            <div v-if="$vuetify.display.width <= 700 || $vuetify.display.width >= 1500" class="width-80 height-80 mr-20 ml-3 flex-shrink-0">
              <svg>
                <use href="@/assets/svg/newImports.svg#operational-chargers-80"></use>
              </svg>
            </div>
            <div v-if="$vuetify.display.width > 700 && $vuetify.display.width < 1500" class="width-60 height-60 ml-20 mr-20 ml-3 flex-shrink-0">
              <svg>
                <use href="@/assets/svg/newImports.svg#operational-chargers-60"></use>
              </svg>
            </div>
      </div>
    </div>
  </el-col>
  
  <el-col
    :class="[
      'd-flex',
      'align-items-center',
      'mt-20',
      $vuetify.display.width < 700 ? 'px-0' : $vuetify.display.width < 1500 ? 'px-10' : 'pl-20 pr-8'
    ]"
    :span="$vuetify.display.width >= 700 ? 8 : 24"
  >
    <div class="row m-0 py-3 width-100-p height-100-p bg-me-primary border-color-light rounded-4 d-flex align-items-center">
      <div class="d-flex justify-content-between align-items-center width-100-p px-2">
        <div class="flex-grow-1 ml-30">
          <p class="font-25-b text-white mb-0">
            {{ dashboardData.decommissioned_charger_count.value.toLocaleString() }}
          </p>
          <p class="font-14 mt-2 text-white mb-0">
             {{ $vuetify.display.width >= 700 && $vuetify.display.width < 1120 ? "Decommis. Chargers" : dashboardData.decommissioned_charger_count.title }}
          </p>
        </div>
            <div v-if="$vuetify.display.width <= 700 || $vuetify.display.width >= 1500" class="width-80 height-80 mr-20 ml-3 flex-shrink-0">
              <svg>
                <use href="@/assets/svg/newImports.svg#decommissioned-chargers-80"></use>
              </svg>
            </div>
            <div v-if="$vuetify.display.width > 700 && $vuetify.display.width <1500" class="width-60 height-60 ml-20 mr-20 ml-3 flex-shrink-0">
              <svg>
                <use href="@/assets/svg/newImports.svg#decommissioned-chargers-60"></use>
              </svg>
            </div>
      </div>
    </div>
  </el-col>
   </el-row>
  </template>
  
  <script>
  export default {
    props: {
      dataProp: {
        type: Array,
        default(rawProps) {
          return rawProps;
        },
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      // ShowDetail,
    },
    data() {
      return {
        show: true,
        dashboardData: {
          supported_charger_count: { title: "Supported Chargers (All MPs)", value: "0" },
          operational_charger_count: { title: "Operational Chargers (All MPs)", value: "0" },
          decommissioned_charger_count: { title: "Decommissioned Chargers (All MPs)", value: "0" },
        },
      };
    },
    watch: {
      dataProp: {
        handler: function (newValue) {
          // console.log(newValue);
          this.dashboardData.supported_charger_count.value = newValue.supported_charger_count;
          this.dashboardData.operational_charger_count.value = newValue.operational_charger_count;
          this.dashboardData.decommissioned_charger_count.value = newValue.decommissioned_charger_count;
        },
        deep: true,
      },
    },
    methods: {},
  };
  </script>
  